import { buildApiUrl } from '../../services/apiConfig';

class IngestDataService {
  async request(endpoint, options = {}) {
    const token = localStorage.getItem('auth_token') || 'dev-token';
    const response = await fetch(buildApiUrl('NOVA_INGESTION', endpoint), {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options.headers,
      },
      ...options,
    });
    if (!response.ok) {
      throw new Error(`API error ${response.status}: ${await response.text()}`);
    }
    return response.json();
  }

  async createOrchestrationPlan(payload) {
    return this.request('/orchestration/plan', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  }

  async getOrchestrationPlan(planId) {
    return this.request(`/orchestration/${planId}`);
  }

  async approveOrchestrationPlan(planId, approved) {
    return this.request(`/orchestration/${planId}/approve`, {
      method: 'POST',
      body: JSON.stringify({ approved }),
    });
  }

  async executeOrchestrationPlan(planId) {
    return this.request(`/orchestration/${planId}/execute`, {
      method: 'POST',
    });
  }

  async listOrchestrations(status, userId, goalSearch, limit = 10, offset = 0) {
    const params = new URLSearchParams();
    if (status)     params.set('status', status);
    if (userId)     params.set('user_id', userId);
    if (goalSearch) params.set('goal_search', goalSearch);
    params.set('limit', String(limit));
    params.set('offset', String(offset));
    return this.request(`/orchestration/?${params.toString()}`);
  }

  async getOrchestrationStats() {
    const response = await this.listOrchestrations(undefined, undefined, undefined, 1000, 0);
    const all = response.orchestrations || [];
    const total = response.total ?? all.length;
    const terminal = all.filter(o => ['completed', 'partial_success', 'failed'].includes(o.status));
    const successes = terminal.filter(o => ['completed', 'partial_success'].includes(o.status));
    const successRate = terminal.length > 0
      ? Math.round((successes.length / terminal.length) * 1000) / 10
      : null;
    const durations = all.map(o => o.actual_duration_ms).filter(d => d != null);
    const avgDurationMs = durations.length > 0
      ? Math.round(durations.reduce((a, b) => a + b, 0) / durations.length)
      : null;
    return { total, successRate, avgDurationMs };
  }
}

export default new IngestDataService();
